import React from 'react';
import { useTranslation } from 'react-i18next';
import { useController, useFormContext } from 'react-hook-form';
import PriceInputWithEarnings from '@wix/da-shared-react/pkg/DollarPriceInput/variants/PriceInputWithEarnings';
import { OriginalDeviationFieldName } from '../../types';

interface Props {}

const PriceField: React.FC<Props> = () => {
  const { t } = useTranslation();
  const { control, errors } = useFormContext();
  const {
    field: { value, onChange },
  } = useController({ name: OriginalDeviationFieldName.PRICE, control });
  const error = errors[OriginalDeviationFieldName.PRICE];

  return (
    <PriceInputWithEarnings
      label={t('originalDeviationPopup.form.price.label')}
      value={value}
      error={error?.message}
      onChange={onChange}
      min={1}
      forceInteger
      isRequired
      noBottomSpacing
      productType="commission"
    />
  );
};
PriceField.displayName = 'PriceField';

export default PriceField;
